import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSemiCloudy({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2376 10.1205C13.2117 10.1205 13.1867 10.1235 13.161 10.1245C12.8727 8.90686 11.7817 8 10.476 8C9.10382 8 7.96876 9.00123 7.75372 10.3119C7.58241 10.2642 7.40255 10.2363 7.21611 10.2363C6.26617 10.2363 5.47308 10.8995 5.2702 11.7879C4.52709 12.0792 4 12.801 4 13.6473C4 14.7505 4.89437 15.6449 5.99786 15.6449H13.2376C14.7637 15.6449 16 14.4082 16 12.8829C16 11.3575 14.7637 10.1202 13.2376 10.1202V10.1205Z"
        fill="white"
      />
      <path
        d="M25.2376 20.1205C25.2117 20.1205 25.1867 20.1235 25.161 20.1245C24.8727 18.9069 23.7817 18 22.476 18C21.1038 18 19.9688 19.0012 19.7537 20.3119C19.5824 20.2642 19.4025 20.2363 19.2161 20.2363C18.2662 20.2363 17.4731 20.8995 17.2702 21.7879C16.5271 22.0792 16 22.801 16 23.6473C16 24.7505 16.8944 25.6449 17.9979 25.6449H25.2376C26.7637 25.6449 28 24.4082 28 22.8829C28 21.3575 26.7637 20.1202 25.2376 20.1202V20.1205Z"
        fill="white"
      />
    </svg>
  );
}
